'use client'

import React from 'react'
import RichText from '@/components/RichText'
import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

type Props = {
  data: DefaultTypedEditorState
  className?: string
}

export const BlogRichText: React.FC<Props> = ({ data, className }) => {
  React.useEffect(() => {
    // Add custom styles for list bullets
    const styleId = 'blog-rich-text-styles'
    // Remove existing style if present
    const existingStyle = document.getElementById(styleId)
    if (existingStyle) {
      existingStyle.remove()
    }

    const style = document.createElement('style')
    style.id = styleId
    style.textContent = `
      .blog-content ul li {
        padding-left: 3rem !important;
      }
      .blog-content ul li::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.5rem;
        width: 1.5rem;
        height: 1.5rem;
        background-color: #0075FF;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"%3e%3cpolyline points="20 6 9 17 4 12"%3e%3c/polyline%3e%3c/svg%3e');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 12px 12px;
        z-index: 1;
      }
    `
    document.head.appendChild(style)

    return () => {
      const styleToRemove = document.getElementById(styleId)
      if (styleToRemove) {
        styleToRemove.remove()
      }
    }
  }, [])

  return (
    <div className="blog-content">
      <RichText
        className={className || "prose prose-lg max-w-none prose-headings:text-[#211F54] prose-headings:font-bold prose-h2:text-3xl prose-h2:mt-12 prose-h2:mb-6 prose-h3:text-2xl prose-h3:mt-10 prose-h3:mb-4 prose-h4:text-xl prose-h4:mt-8 prose-h4:mb-3 prose-h5:text-lg prose-h5:mt-6 prose-h5:mb-2 prose-h6:text-base prose-h6:mt-4 prose-h6:mb-2 prose-p:text-gray-600 prose-p:leading-relaxed prose-p:mb-6 prose-a:text-[#0075FF] prose-a:underline prose-strong:text-gray-800 prose-ul:my-6 prose-ul:list-none prose-ul:pl-0 prose-li:text-gray-600 prose-li:mb-4 prose-li:pl-12 prose-li:relative prose-blockquote:border-l-4 prose-blockquote:border-[#0075FF] prose-blockquote:pl-6 prose-blockquote:italic prose-blockquote:text-gray-700 prose-blockquote:my-8 prose-ol:my-6 prose-ol:list-decimal prose-ol:pl-12"}
        data={data}
        enableGutter={false}
      />
    </div>
  )
}